import { storageSlice as slice } from './storage-slice.js'
import * as thunks from './storage-thunks.js'

/** Decorate the thunks in the slice */
export const storageFeature = {
  actions: slice.actions,
  thunks,
}
